import { render, staticRenderFns } from "./googleLoginButton.vue?vue&type=template&id=14e95b22&scoped=true"
import script from "./googleLoginButton.vue?vue&type=script&lang=js"
export * from "./googleLoginButton.vue?vue&type=script&lang=js"
import style1 from "./googleLoginButton.vue?vue&type=style&index=1&id=14e95b22&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e95b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/social-login-buttons/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e95b22')) {
      api.createRecord('14e95b22', component.options)
    } else {
      api.reload('14e95b22', component.options)
    }
    module.hot.accept("./googleLoginButton.vue?vue&type=template&id=14e95b22&scoped=true", function () {
      api.rerender('14e95b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/googleLoginButton.vue"
export default component.exports